import React from "react";

export function TextareaInput({
  type,
  disabled,
  value,
  onChange,
  fieldClasses,
  placeholder,
}) {
  return (
    <textarea
      placeholder={placeholder}
      className={`p-3 border border-gray-400 outline-none focus:border-gray-800 rounded w-full ${
        disabled && "bg-gray-200"
      } ${fieldClasses || ""}`}
      name={name}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  );
}
